import { Suspense } from 'react';

import { lazyWithReload } from '@/app/lazyWithReload';

import { useSvgConvertStore } from './svgConvertStore';

/**
 * SvgConvertHost — 全站唯一一份 SVG 轉檔確認視窗的掛點(R415;掛在 Providers)
 *
 * 只在佇列有東西時才載入視窗那支 chunk:轉檔管線(DOMParser / canvas / 去背)與視窗
 * 都不進主 bundle(R413「主 bundle 只裝每個訪客都要的東西」)。這支檔案本身只多了
 * 一個 zustand selector。
 */
const SvgConvertDialogConnected = lazyWithReload(
  'svgConvertDialog',
  () => import('./SvgConvertDialog'),
);

export function SvgConvertHost() {
  const pending = useSvgConvertStore((s) => s.queue.length > 0);
  if (!pending) return null;
  return (
    <Suspense fallback={null}>
      <SvgConvertDialogConnected />
    </Suspense>
  );
}
